import { OtherService } from "../services/other.service"

const data = {}

// city
export async function getListCity() {
  if(data.listCity) return data.listCity
  try {
    const response = await OtherService.getlistCity()
    const listCity = response.data.map((e) => {
      return {
        id: e.code,
        text: e.name,
        queryText: removeVietnameseTonesAndToLowerCase(e.name) 
      }
    })
    data.listCity = listCity
    return listCity
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function getCityName(cityCode) {
  if(!cityCode) {
    throw("error:params must had cityCode");
  }
  const listCity = await getListCity()
  const cityName = listCity.find(e => e.id == cityCode)
  return cityName ? cityName.text : ""
}

// District
export async function getListDistrict(cityCode) {
  if(!cityCode) {
    return []
    // throw("error:params must had cityCode");
  }
  if(data["list_district_"+cityCode]) return data["list_district_"+cityCode]
  try {
    const response = await OtherService.getlistDistrict({
      cityCode,
      countryCode: "vn",
    });
    const listDistrict = response.data.map((e) => {
      return {
        id: e.code,
        text: e.name,
        queryText: removeVietnameseTonesAndToLowerCase(e.name) 
      }
    })
    data["list_district_"+cityCode] = listDistrict
    return listDistrict
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function getDistrictName(cityCode, districtCode) {
  if(!cityCode || !districtCode) {
    throw("error:params must had cityCode and districtCode");
  }
  const listDistrict = await getListDistrict(cityCode)
  const districtName = listDistrict.find(e => e.id == districtCode)
  return districtName ? districtName.text : ""
}

// Ward
export async function getListWard(cityCode, districtCode) {
  if(!cityCode || !districtCode) {
    return []
    // throw("error:params must had cityCode and districtCode");
  }
  if(data["list_ward_"+districtCode]) return data["list_ward_"+districtCode]
  try {
    const response = await OtherService.getlistWard({
      countryCode: "vn",
      cityCode,
      districtCode,
    });
    const listWard = response.data.map((e) => {
      return {
        id: e.code,
        text: e.name,
        queryText: removeVietnameseTonesAndToLowerCase(e.name) 
      }
    })
    data["list_ward_"+districtCode] = listWard
    return listWard
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function getWardName(cityCode, districtCode, wardCode) {
  if(!cityCode || !districtCode || !wardCode) {
    throw("error:params must had cityCode, districtCode and wardCode");
  }
  const listDistrict = await getListWard(cityCode, districtCode)
  const wardName = listDistrict.find(e => e.id == wardCode)
  return wardName ? wardName.text : ""
}

// getAllName
export async function getAllAddressName(cityCode, districtCode, wardCode) {
  let cityName, districtName, wardName
  cityName = cityCode ? getCityName(cityCode) : ""
  districtName = cityCode && districtCode ? await getDistrictName(cityCode, districtCode) : ""
  wardName = cityCode && districtCode && wardCode ? await getWardName(cityCode, districtCode, wardCode) : ""
  const result = await Promise.all([cityName, districtName, wardName])
  const address = {
    cityName: result[0],
    districtName: result[1],
    wardName: result[2],
  }
  return address
}

function removeVietnameseTones(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"); 
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"); 
  str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i"); 
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"); 
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"); 
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"); 
  str = str.replace(/đ/g,"d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g," ");
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
  return str;
}

export function removeVietnameseTonesAndToLowerCase(str) {
  str = removeVietnameseTones(str).toLowerCase()
  return str;
}